import {
  iconButtonClasses,
  inputAdornmentClasses,
  inputBaseClasses,
  outlinedInputClasses,
  selectClasses,
  svgIconClasses,
} from '@mui/material';
// import type { Components } from '@mui/material/styles';
import { KeyboardArrowDownRounded } from '@mui/icons-material';

import {
  fontSizeLarge,
  fontSizeMedium,
  fontSizeSmall,
  fontSizeXSmall,
  iconSizeLarge,
  iconSizeMedium,
  iconSizeSmall,
  iconSizeXSmall,
  largeSize,
  mediumSize,
  smallSize,
  xSmallSize,
} from '@/mui/components/constants';
import { SHAPE_CIRCULAR, SHAPE_SQUARE } from '@/mui/constants';

const fontSizes = {
  xSmall: fontSizeXSmall,
  small: fontSizeSmall,
  medium: fontSizeMedium,
  large: fontSizeLarge,
};

const sizes = {
  xSmall: xSmallSize,
  small: smallSize,
  medium: mediumSize,
  large: largeSize,
};

const iconSizes = {
  xSmall: iconSizeXSmall,
  small: iconSizeSmall,
  medium: iconSizeMedium,
  large: iconSizeLarge,
};

const paddingSizes = {
  xSmall: [4, 4],
  small: [6.5, 6],
  medium: [8, 8],
  large: [11, 11],
};

export const CUSTOM_ATTRIBUTE_SHAPE = 'data-0';
export const CUSTOM_ATTRIBUTE_TEXT_ALIGN = 'data-1';

export default function MUITextField() /* : Components['MuiTextField'] */ {
  return {
    defaultProps: {
      fullWidth: true,
      SelectProps: {
        IconComponent: KeyboardArrowDownRounded,
      },
    },
    variants: [
      {
        props: { [CUSTOM_ATTRIBUTE_SHAPE]: SHAPE_SQUARE },
        style: {
          [`.${inputBaseClasses.root}`]: {
            borderRadius: 0,

            '&:before': {
              left: 0,
              right: 0,
            },

            '&:after': {
              left: 0,
              right: 0,
            },
          },
        },
      },
      {
        props: { [CUSTOM_ATTRIBUTE_SHAPE]: SHAPE_CIRCULAR },
        style: {
          [`.${inputBaseClasses.root}`]: {
            borderRadius: '100vw',

            '&:before': {
              left: 16,
              right: 16,
            },

            '&:after': {
              left: 16,
              right: 16,
            },
          },
        },
      },
      {
        props: { [CUSTOM_ATTRIBUTE_TEXT_ALIGN]: 'center' },
        style: {
          [`.${inputBaseClasses.input}`]: {
            textAlign: 'center',
          },
        },
      },
      {
        props: { [CUSTOM_ATTRIBUTE_TEXT_ALIGN]: 'right' },
        style: {
          [`.${inputBaseClasses.input}`]: {
            textAlign: 'right',
          },
        },
      },
      {
        props: { margin: 'none' },
        style: {
          [`.${inputBaseClasses.input}`]: {
            paddingLeft: 0,
            paddingRight: 0,
          },
          [`.${outlinedInputClasses.root}`]: {
            paddingLeft: 0,
            paddingRight: 0,
          },
        },
      },
      ...Object.keys(fontSizes).map((size) => {
        const inputSize = sizes[size as keyof typeof sizes];
        const iconSize = iconSizes[size as keyof typeof iconSizes];
        const [mPTop, mPBottom] = paddingSizes[size as keyof typeof paddingSizes];
        const fontSize = fontSizes[size as keyof typeof fontSizes];

        return {
          props: { size },
          style: {
            fontSize,
            [`& .${selectClasses.icon}`]: {
              fontSize: iconSize,
            },
            [`& .${inputBaseClasses.root}`]: {
              fontSize,
              paddingTop: 0,
              paddingBottom: 0,
              minHeight: inputSize,
            },
            [`& .${iconButtonClasses.root}`]: {
              fontSize: iconSize,
              width: inputSize,
              height: inputSize,
            },
            [` .${inputAdornmentClasses.root}`]: {
              fontSize: iconSize,
              minHeight: inputSize,

              [`& > .${svgIconClasses.root}`]: {
                fontSize: iconSize,
                minWidth: inputSize,
              },
            },
            [` .${outlinedInputClasses.notchedOutline}`]: {
              fontSize,
            },
            [` .${inputBaseClasses.input}`]: {
              fontSize,
              height: inputSize,
            },
            [`& .${inputBaseClasses.inputMultiline}`]: {
              marginTop: mPTop,
              marginBottom: mPBottom,
            },
          },
        };
      }),
    ],
    styleOverrides: {
      root: {
        position: 'relative',

        '&:before': {
          left: 4,
          right: 4,
        },

        '&:after': {
          left: 4,
          right: 4,
        },
      },
    },
    // variants: [],
  };
}
